import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReviewDate from './ReviewDate';
import { Rating } from './Rating';
import { Source } from './Source';
import { ReviewContent } from './ReviewContent';
import { ReviewModal } from './ReviewModal';

const Review = ({
	review,
	singleSource,
	windowId,
	reviewTruncationLength,
	labels,
	fontSize,
	reviewDateFontSize,
	ratingStarFullFillColor,
	seeFullReviewColor
}) => {
	const [showModal, setShowModal] = useState(false);
	const { source, rating, content, author, reviewDate, replies } = review;

	let replyData;
	if (replies) {
		if (Array.isArray(replies)) {
			// eslint-disable-next-line prefer-destructuring
			replyData = replies[0];
		}
	}

	const showReply = Boolean(replyData) && content;

	const openModal = () => {
		setShowModal(true);
	};

	const closeModal = () => {
		setShowModal(false);
	};

	return (
		<div className="review px-sm-6">
			<div className="row mb-3">
				<div className="rating-wrap col-xs-9">
					<div className="d-flex align-items-center flex-wrap overflow-hidden">
						<h4 className="m-0 mr-3">{author}</h4>
						{!singleSource && (
							<Source
								source={source}
								singleSource={singleSource}
							/>
						)}
					</div>
					<Rating
						rating={rating}
						source={source}
						labels={labels}
						fontSize={fontSize}
						ratingStarFullFillColor={ratingStarFullFillColor}
					/>
					<ReviewDate
						reviewDate={reviewDate}
						fontSize={reviewDateFontSize}
					/>
				</div>
			</div>
			<ReviewContent
				truncate
				fontSize={fontSize}
				content={content}
				openModal={() => openModal()}
				windowId={windowId}
				seeFullReviewColor={seeFullReviewColor}
				maxCharacters={reviewTruncationLength}
				seeFullReviewBtnText={labels.get('SEE_FULL_REVIEW')}
				seeFullReviewBtnAriaLabel={`${labels.get(
					'SEE_FULL_REVIEW_BY'
				)} ${author}`}
				showSeeFullReviewBtn={showReply}
			/>
			{showReply && (
				<div>
					<p className={fontSize}>1 response</p>
				</div>
			)}
			{showModal && (
				<ReviewModal
					show={showModal}
					closeModal={() => closeModal()}
					author={author}
					content={content}
					source={source}
					reviewDate={reviewDate}
					rating={rating}
					singleSource={singleSource}
					labels={labels}
					fontSize={fontSize}
					reviewDateFontSize={reviewDateFontSize}
					showReply={showReply}
					replyData={replyData}
				/>
			)}
		</div>
	);
};

Review.propTypes = {
	review: PropTypes.shape({
		source: PropTypes.string.isRequired,
		author: PropTypes.string.isRequired,
		content: PropTypes.string.isRequired,
		rating: PropTypes.number.isRequired,
		reviewDate: PropTypes.string.isRequired,
		replies: PropTypes.arrayOf(
			PropTypes.shape({
				reply: PropTypes.string,
				replyDate: PropTypes.string
			})
		)
	}).isRequired,
	singleSource: PropTypes.bool.isRequired,
	windowId: PropTypes.string.isRequired,
	reviewTruncationLength: PropTypes.number.isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func
	}).isRequired,
	fontSize: PropTypes.string,
	reviewDateFontSize: PropTypes.string,
	ratingStarFullFillColor: PropTypes.string,
	seeFullReviewColor: PropTypes.string
};

Review.defaultProps = {
	fontSize: '',
	reviewDateFontSize: '',
	seeFullReviewColor: ''
};

export default Review;
